import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DailyLead } from '../lead.model';

@Component({
  selector: 'app-lead-detail-modal-legacy',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './lead-detail-modal.component.html',
})
export class LeadDetailModalLegacyComponent {
  @Input() lead: DailyLead | null = null;
  @Input() loading = false;
  @Output() closeModal = new EventEmitter<void>();

  photoError = false;

  @HostListener('document:keydown.escape')
  onEscapePress(): void {
    this.close();
  }

  close(): void {
    this.closeModal.emit();
  }

  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('modal-backdrop')) {
      this.close();
    }
  }

  get initials(): string {
    if (!this.lead) return '';
    return (
      (this.lead.person_first_name?.[0] || '') +
      (this.lead.person_last_name?.[0] || '')
    ).toUpperCase();
  }

  get matchColor(): string {
    if (!this.lead) return 'text-gray-500';
    if (this.lead.icp_score >= 80) return 'text-green-600 dark:text-green-400';
    if (this.lead.icp_score >= 60) return 'text-orange-500 dark:text-orange-400';
    return 'text-red-500 dark:text-red-400';
  }

  get matchBarColor(): string {
    if (!this.lead) return 'bg-gray-400';
    if (this.lead.icp_score >= 80) return 'bg-green-500';
    if (this.lead.icp_score >= 60) return 'bg-orange-400';
    return 'bg-red-400';
  }

  get photoUrl(): string | null {
    return this.lead?.apollo_person_data?.photo_url || null;
  }

  get departments(): string[] {
    return this.lead?.apollo_person_data?.departments || [];
  }

  get companyLogoUrl(): string | null {
    return this.lead?.apollo_company_data?.logo_url || null;
  }

  get companyAddress(): string | null {
    return this.lead?.apollo_person_data?.organization?.raw_address || null;
  }

  get breakdownEntries(): { key: string; label: string; item: any }[] {
    if (!this.lead?.icp_match_breakdown) return [];
    return Object.entries(this.lead.icp_match_breakdown)
      .filter(([, value]) => value != null)
      .map(([key, value]) => ({
        key,
        label: key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
        item: value,
      }));
  }

}
